<script setup>
import BreezeButton from "@/Components/AuthButton.vue";
import BreezeGuestLayout from "@/Layouts/Guest.vue";
import BreezeInput from "@/Components/Input.vue";
import BreezeLabel from "@/Components/Label.vue";
import BreezeValidationErrors from "@/Components/ValidationErrors.vue";
import { Head, useForm } from "@inertiajs/inertia-vue3";

const props = defineProps({
  email: String,
  token: String,
});

const form = useForm({
  token: props.token,
  email: props.email,
  password: "",
  password_confirmation: "",
});

const submit = () => {
  form.post(route("password.update"), {
    onFinish: () => form.reset("password", "password_confirmation"),
  });
};
</script>

<template>
  <BreezeGuestLayout>
    <div
      class="
        w-full
        sm:max-w-lg
        mt-6
        px-24
        py-12
        bg-oteoBlue-600
        shadow-md
        overflow-hidden
        sm:rounded-lg
      "
    >
      <Head title="Passwort zurücksetzen" />

      <BreezeValidationErrors class="mb-4" />

      <form @submit.prevent="submit">
        <div>
          <BreezeLabel for="email" value="E-Mail Adresse" />
          <BreezeInput
            id="email"
            type="email"
            class="mt-1 block w-full"
            v-model="form.email"
            required
            autofocus
            autocomplete="email"
          />
        </div>

        <div class="mt-4">
          <BreezeLabel for="password" value="Passwort" />
          <BreezeInput
            id="password"
            type="password"
            class="mt-1 block w-full"
            v-model="form.password"
            required
            placeholder="Bitte eingeben"
            autocomplete="password"
          />
        </div>

        <div class="mt-4">
          <BreezeLabel
            for="password_confirmation"
            value="Passwort wiederholen"
          />
          <BreezeInput
            id="password_confirmation"
            type="password"
            class="mt-1 block w-full"
            v-model="form.password_confirmation"
            required
            placeholder="Bitte eingeben"
            autocomplete="password_confirmation"
          />
        </div>

        <div class="flex items-center justify-end mt-4">
          <BreezeButton
            :class="{ 'opacity-25': form.processing }"
            :disabled="form.processing"
          >
            Zurücksetzen
          </BreezeButton>
        </div>
      </form>
    </div>
  </BreezeGuestLayout>
</template>
